import http from '../httpService';

const VersionService = {
  getVersions: () => http.get('versions/application'),
};

export default VersionService;
